<template>
	<view class="form-text" v-if="showText" @click="open">{{ formattedAcType || title }}</view>
	<nut-popup position="bottom" v-model:visible="state.visible">
		<view class="safe-area">
			<nut-picker v-model="state.value" :columns="columns" :title="title" @confirm="submit" @cancel="close">
				<slot></slot>
			</nut-picker>
		</view>
	</nut-popup>
</template>
<script setup>
import { reactive, computed, watch } from "vue"
// import { isArray } from "lodash-es"
// import { getFullCode } from "."

const props = defineProps({
	modelValue: {
		type: [String, Number, Array],
		default() {
			return ""
		},
	},
	showText: {
		//直接在form中显示
		type: Boolean,
		default: true,
	},
	title: {
		type: String,
		default: "请选择",
	},
	ischange: {
		//是否需要转换state.text
		type: Boolean,
		default: false,
	},
	columns: {
		type: Array,
		default() {
			return []
		},
	},
})

const state = reactive({
	visible: false,
	value: [],
	text: "",
})
const emits = defineEmits(["update:modelValue"])

const proccessModelValue = (value) => {
	state.value.push(value)
}

watch(
	() => props.modelValue,
	(newV) => {
		if (props.showText) {
			proccessModelValue(newV)
			getText()
		}
	},
)
const getText = () => {
	state.text = props.modelValue
}
getText()

const submit = ({ selectedOptions }) => {
	if (props.ischange) {
		state.text = selectedOptions.map((val) => val.value).join(",")
	} else {
		state.text = selectedOptions.map((val) => val.text).join(",")
	}

	emits("update:modelValue", state.text)
	state.visible = false
}

const formattedAcType = computed(() => {
	const acType = state.text
	if (props.ischange) {
		const matchedOption = props.columns.find((item) => item.value === acType)
		if (matchedOption) {
			return matchedOption.text
		}
	}
	return acType
})

const close = () => {
	state.visible = false
}

const open = () => {
	state.visible = true
}
defineExpose({ open })
</script>
